import { createContext } from "react";

export const LoadingContext = createContext({
  order: {},
  onChange: () => {},
  _stationData: {},
  _shipDocData: {},
});
